import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { AuthenticationConverter, AuthenticationEndPoints, AuthenticationModel, AuthenticationResetPasswordApiData, AuthenticationSignInApiResultData, AuthenticationSignInCookieApiData, AuthenticationSignUpApiData, CheckUtils, ConversationsSettingsModel, EncryptStorage, EncryptStorageEvent, Guid, logger, OrganizationModel, UpdateModelVoData, UserResolverVoData, UsersProvider, UsersResolverModel, UserStatusVoData } from "../..";
import { ConversationsProviderEvent } from "../chat/conversations-provider";
var AuthenticationProvider = /** @class */ (function () {
    function AuthenticationProvider(_encryptStorage, _authEndPoints, _userProvider, _model, _usersResolverModel, _organizationModel, _conversationsSettingsModel, _events) {
        this._encryptStorage = _encryptStorage;
        this._authEndPoints = _authEndPoints;
        this._userProvider = _userProvider;
        this._model = _model;
        this._usersResolverModel = _usersResolverModel;
        this._organizationModel = _organizationModel;
        this._conversationsSettingsModel = _conversationsSettingsModel;
        this._events = _events;
        this._ready = false;
        this._bc = ("BroadcastChannel" in self) ? new BroadcastChannel("auth") : null;
        this.setup();
        this.bind();
    }
    AuthenticationProvider.prototype.setup = function () {
        var _this = this;
        this._restoreSignedHandler = function (authenticationToken) {
            if (_this._model != null && authenticationToken != null) {
                _this.model.setAuthenticationToken(authenticationToken);
                logger.info("AuthenticationProvider - restore signed : true");
                _this._events.publish(AuthenticationProviderEvent.SIGNED, true);
            }
        };
        this._cookieLoadedHandler = function (cookie) {
            _this.signInWithCookie(cookie);
            _this._ready = true;
            _this._events.publish(ConversationsProviderEvent.READY);
        };
        this._jidChangedHandler = function () {
            if (CheckUtils.isEmpty(_this._model.userId))
                return;
            logger.info("AuthenticationProvider - jid changed for userid : " + _this._model.userId);
            if (CheckUtils.isEmpty(_this._model.jid)) {
                logger.info("AuthenticationProvider - status changed to " + UserStatusVoData.OFFLINE + " for userid : " + _this._model.userId);
                _this._userProvider.model.update(_this._model.userId, [new UpdateModelVoData("status", UserStatusVoData.OFFLINE)]);
            }
            else {
                logger.info("AuthenticationProvider - status changed to " + UserStatusVoData.ONLINE + " for userid : " + _this._model.userId);
                _this._usersResolverModel.add(new UserResolverVoData(_this._model.userId, _this._model.jid.bare));
                _this._userProvider.model.update(_this._model.userId, [new UpdateModelVoData("status", UserStatusVoData.ONLINE)]);
            }
        };
        this._loadedHandler = function () {
            _this.getUser(_this._model.userId);
            _this._restoreSignedHandler(_this.model.authenticationToken);
        };
        this._localStorageCreated = function () {
            logger.info("AuthenticationProvider - local storage created: true");
            _this._model.clear(false, true);
            if (_this._bc != null)
                _this._bc.postMessage({ message: AuthenticationBCEvent.NEW_TAB });
            setTimeout(function () { return _this._model.loadData(); }, 500);
        };
        this._encryptStorageLoadedHandler = function (res) {
            _this._model.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        };
        this._broadcastHandler = function (e) {
            switch (e.data.message) {
                case AuthenticationBCEvent.NEW_TAB:
                    logger.info("AuthenticationProvider -open  new tab");
                    _this.sendSignIn();
                    break;
                case AuthenticationBCEvent.SIGN_IN:
                    if (!CheckUtils.isEmpty(e.data.messageData) && !CheckUtils.isEmpty(e.data.messageData.uri) &&
                        e.data.messageData.uri === _this._organizationModel.uri && CheckUtils.isEmpty(_this._model.authenticationToken)) {
                        logger.info("AuthenticationProvider - broadcast sign in : true");
                        _this.onSigned(true, e.data.messageData.auth);
                    }
                    break;
                case AuthenticationBCEvent.SIGN_OUT:
                    if (!CheckUtils.isEmpty(e.data.messageData) && !CheckUtils.isEmpty(e.data.messageData.uri) &&
                        e.data.messageData.uri === _this._organizationModel.uri) {
                        _this._conversationsSettingsModel.setLiveSupportProvided(e.data.messageData.liveSupportProvided);
                        logger.info("AuthenticationProvider - broadcast sign out : true");
                        _this.onSigned(false, e.data.messageData.auth);
                    }
                    break;
                case AuthenticationBCEvent.LIVE_ONLINE_PROVIDED:
                    if (!CheckUtils.isEmpty(e.data.messageData) && e.data.messageData.uri === _this._organizationModel.uri) {
                        logger.info("AuthenticationProvider - broadcast live online provided : " + e.data.messageData.value);
                    }
                    break;
            }
        };
        this._connectHandler = function () {
            _this._model.setAuthenticationToken(null);
            _this.signInWithCookie(_this._model.cookie);
        };
    };
    AuthenticationProvider.prototype.bind = function () {
        if (this._bc != null)
            this._bc.onmessage = this._broadcastHandler;
        this._authEndPoints.connectHandler = this._connectHandler;
        this._events.subscribe(this.model.event.JID_CHANGED, this._jidChangedHandler);
        this._events.subscribe(this.model.event.TOKEN_LOADED, this._restoreSignedHandler);
        this._events.subscribe(this.model.event.COOKIE_LOADED, this._cookieLoadedHandler);
        this._events.subscribe(this.model.event.LOADED, this._loadedHandler);
        this._events.subscribe(EncryptStorageEvent.LOCAL_STORAGE_CREATED, this._localStorageCreated);
        this._events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, this._encryptStorageLoadedHandler);
        this._events.subscribe(AuthenticationProviderEvent.AUTO_SIGNED, this._restoreSignedHandler);
    };
    Object.defineProperty(AuthenticationProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationProvider.prototype.signUp = function (email) {
        var _this = this;
        this._authEndPoints.signUp(new AuthenticationSignUpApiData(this._organizationModel.uri, email))
            .then(function (res) {
            logger.info("AuthenticationProvider - sign up : true");
            _this._events.publish(AuthenticationProviderEvent.REGISTER_ASKED, res);
        })
            .catch(function (err) {
            logger.info("AuthenticationProvider - sign up : false");
            _this._events.publish(AuthenticationProviderEvent.REGISTER_ASKED, false);
            logger.info(err);
        });
    };
    AuthenticationProvider.prototype.signIn = function (value) {
        var _this = this;
        /*When value is empty, sign in with the cookie*/
        if (CheckUtils.isEmpty(value) || CheckUtils.isEmpty(value.email) || CheckUtils.isEmpty(value.password)) {
            this.onSigned(false);
            logger.warn("Warning on sign in. Email or/and password is/are not defined.");
        }
        value.uri = this._organizationModel.uri;
        this._authEndPoints.signIn(value)
            .then(function (res) {
            logger.info("AuthenticationProvider - sign in : true");
            _this.onSigned(true, res, true);
        })
            .catch(function (err) {
            logger.info("AuthenticationProvider - sign in : false");
            _this.onSigned(false);
            logger.info(err);
        });
    };
    AuthenticationProvider.prototype.signInWithCookie = function (cookie) {
        var _this = this;
        if (!this.isAuthenticated()) {
            if (!CheckUtils.isEmpty(cookie)) {
                this._authEndPoints.signInWithCookie(new AuthenticationSignInCookieApiData(this._organizationModel.uri, this._model.cookie))
                    .then(function (res) {
                    logger.info("AuthenticationProvider - sign in with cookie : true");
                    _this.onSigned(true, res, true);
                })
                    .catch(function (err) {
                    logger.info("AuthenticationProvider - sign in with cookie : false");
                    _this.onSigned(false);
                    logger.info(err);
                });
            }
            else {
                logger.info("AuthenticationProvider - sign in with cookie : false");
                this.onSigned(false);
            }
        }
    };
    AuthenticationProvider.prototype.is2FAEnabled = function (email) {
        return this._authEndPoints.is2FAEnabled(email);
    };
    AuthenticationProvider.prototype.getAuthByCode = function (email) {
        return this._authEndPoints.getAuthByCode(email);
    };
    AuthenticationProvider.prototype.sendCodeByLoginName = function (email, uri) {
        var data = { email: email };
        if (uri != null && uri !== "") {
            data["uri"] = uri;
        }
        return this._authEndPoints.sendCodeByLoginName(data);
    };
    AuthenticationProvider.prototype.signOut = function () {
        logger.info("AuthenticationProvider - sign out : true");
        this.onSigned(false, null, true);
    };
    AuthenticationProvider.prototype.validatePassword = function (password) {
        return this._authEndPoints.validatePassword(password);
    };
    AuthenticationProvider.prototype.resetPassword = function (email) {
        var _this = this;
        this._authEndPoints.resetPassword(new AuthenticationResetPasswordApiData(this._organizationModel.uri, email))
            .then(function (res) {
            logger.info("AuthenticationProvider - reset password : true");
            _this._events.publish(AuthenticationProviderEvent.RESET_PASSWORD_ASKED, true);
        })
            .catch(function (err) {
            logger.info("AuthenticationProvider - reset password : false");
            _this._events.publish(AuthenticationProviderEvent.RESET_PASSWORD_ASKED, false);
            logger.info(err);
        });
    };
    AuthenticationProvider.prototype.isAuthenticated = function () {
        return this._model != null && this._model.authenticationToken != null;
    };
    AuthenticationProvider.prototype.validateRegistration = function (uuid, authenticationValidateConfirmationApiData) {
        var _this = this;
        this._authEndPoints.validateRegistration(uuid, AuthenticationConverter.convertToAuthenticationValidateConfirmationApiData(authenticationValidateConfirmationApiData))
            .then(function (res) {
            logger.info("AuthenticationProvider - validate registration : true");
            _this._events.publish(AuthenticationProviderEvent.REGISTRATION_VALIDATED, true);
        })
            .catch(function (err) {
            logger.info("AuthenticationProvider - validate registration : false");
            _this._events.publish(AuthenticationProviderEvent.REGISTRATION_VALIDATED, false);
            logger.info(err);
        });
    };
    AuthenticationProvider.prototype.processConfirmation = function (uuid, authenticationProcessConfirmationApiData) {
        var _this = this;
        this._authEndPoints.processConfirmation(uuid, AuthenticationConverter.convertToAuthenticationProcessConfirmationApiData(authenticationProcessConfirmationApiData))
            .then(function (res) {
            logger.info("AuthenticationProvider - process confirmation : true");
            _this._events.publish(AuthenticationProviderEvent.CONFIRMATION_PROCESSED, res);
        })
            .catch(function (err) {
            logger.info("AuthenticationProvider - process confirmation : false");
            _this._events.publish(AuthenticationProviderEvent.CONFIRMATION_PROCESSED, null);
            logger.info(err);
        });
    };
    AuthenticationProvider.prototype.sendSignIn = function () {
        var authData = new AuthenticationSignInApiResultData();
        authData.authenticationToken = this._model.authenticationToken;
        authData.secretPassphrase = this._encryptStorage.secretPassphrase;
        authData.cookie = this._model.cookie;
        authData.userId = this._model.userId;
        authData.jid = this._model.jid;
        var messageData = { uri: this._organizationModel.uri, auth: authData };
        logger.info("AuthenticationProvider - send sign in");
        if (this._bc != null)
            this._bc.postMessage({ message: AuthenticationBCEvent.SIGN_IN, messageData: messageData });
    };
    AuthenticationProvider.prototype.sendSignOut = function () {
        this._encryptStorage.setSecretPassphrase(Guid.guid());
        this._model.setAuthenticationToken(null);
        this._model.setCookie(null);
        this._conversationsSettingsModel.setLiveSupportProvided(false);
        var authData = new AuthenticationSignInApiResultData();
        authData.authenticationToken = this._model.authenticationToken;
        authData.secretPassphrase = this._encryptStorage.secretPassphrase;
        authData.cookie = this._model.cookie;
        authData.liveSupportProvided = this._conversationsSettingsModel.liveSupportProvided;
        var messageData = { uri: this._organizationModel.uri, auth: authData };
        logger.info("AuthenticationProvider - send sign out");
        if (this._bc != null)
            this._bc.postMessage({ message: AuthenticationBCEvent.SIGN_OUT, messageData: messageData });
    };
    AuthenticationProvider.prototype.onSigned = function (value, user, send) {
        var _this = this;
        if (send === void 0) { send = false; }
        if (!CheckUtils.isEmpty(user) && !CheckUtils.isEmpty(user.secretPassphrase))
            this._encryptStorage.setSecretPassphrase(user.secretPassphrase);
        if (CheckUtils.isEmpty(this._encryptStorage.secretPassphrase))
            this._encryptStorage.setSecretPassphrase(Guid.guid());
        if (value) {
            if (CheckUtils.isEmpty(user) || CheckUtils.isEmpty(user.authenticationToken)) {
                return;
            }
            else if (CheckUtils.isEmpty(user.userId)) {
                this._authEndPoints.loginUserDescriptions(user.authenticationToken).then(function (userInfo) {
                    if (userInfo != null && userInfo.userId != null) {
                        user.userId = userInfo.userId;
                        _this.register(user, send);
                    }
                })
                    .catch(function (err) {
                    logger.error("AuthenticationProvider - get login user descriptions : failed");
                    logger.error(err);
                    return;
                });
            }
            else {
                this.register(user, send);
            }
        }
        else {
            if (send)
                this.sendSignOut();
            if (send || CheckUtils.isEmpty(this._model.userId))
                this.getUser(null);
        }
        logger.info("AuthenticationProvider - signed : " + value);
        this._events.publish(AuthenticationProviderEvent.SIGNED, value);
    };
    AuthenticationProvider.prototype.register = function (user, send) {
        this._model.setAuthenticationToken(user.authenticationToken);
        this._model.setCookie(user.cookie);
        this._model.setUserId(user.userId);
        if (send)
            this.sendSignIn();
        this.getUser(user.userId);
    };
    AuthenticationProvider.prototype.getUser = function (userId) {
        var _this = this;
        if (CheckUtils.isEmpty(userId)) {
            logger.info("AuthenticationProvider - user signed as Anonymous");
            this._events.publish(AuthenticationProviderEvent.USER_SIGNED, this.getAnonymous());
        }
        else {
            this._userProvider.get(new Set([userId]), function (users) {
                var user;
                if (CheckUtils.isEmpty(users)) {
                    user = _this.getAnonymous();
                    logger.info("AuthenticationProvider - user signed as Anonymous");
                }
                else {
                    user = users.get(userId);
                    logger.info("AuthenticationProvider - user signed as userid:" + user.id);
                }
                _this._events.publish(AuthenticationProviderEvent.USER_SIGNED, user);
            });
        }
    };
    AuthenticationProvider.prototype.getAnonymous = function () {
        var anonymous = this._userProvider.addAnonymous();
        this._model.setUserId(anonymous.id);
        return anonymous;
    };
    AuthenticationProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AuthenticationProvider.ctorParameters = function () { return [
        { type: EncryptStorage, },
        { type: AuthenticationEndPoints, },
        { type: UsersProvider, },
        { type: AuthenticationModel, },
        { type: UsersResolverModel, },
        { type: OrganizationModel, },
        { type: ConversationsSettingsModel, },
        { type: Events, },
    ]; };
    return AuthenticationProvider;
}());
export { AuthenticationProvider };
export var AuthenticationProviderEvent;
(function (AuthenticationProviderEvent) {
    AuthenticationProviderEvent["READY"] = "authentication:ready";
    AuthenticationProviderEvent["AUTO_SIGNED"] = "authentication:auto-signed";
    AuthenticationProviderEvent["SIGNED"] = "authentication:signed";
    AuthenticationProviderEvent["USER_SIGNED"] = "authentication-user:signed";
    AuthenticationProviderEvent["REGISTER_ASKED"] = "authentication-register:asked";
    AuthenticationProviderEvent["REGISTRATION_VALIDATED"] = "authentication-register:validated";
    AuthenticationProviderEvent["CONFIRMATION_PROCESSED"] = "authentication-confirm:processed";
    AuthenticationProviderEvent["RESET_PASSWORD_ASKED"] = "authentication-reset-password:asked";
})(AuthenticationProviderEvent || (AuthenticationProviderEvent = {}));
export var AuthenticationBCEvent;
(function (AuthenticationBCEvent) {
    AuthenticationBCEvent["NEW_TAB"] = "authentication:new-tab";
    AuthenticationBCEvent["SIGN_IN"] = "authentication:sign-in";
    AuthenticationBCEvent["SIGN_OUT"] = "authentication:sign-out";
    AuthenticationBCEvent["LIVE_ONLINE_PROVIDED"] = "authentication-live-online:provided";
})(AuthenticationBCEvent || (AuthenticationBCEvent = {}));
//# sourceMappingURL=authentication-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/authentication/authentication-provider.js
// module id = 351
// module chunks = 14